module.exports = __webpack_public_path__ + "img/ci_front_es.ec68caee.png";